<script>
    export let assets;
</script>

<div class="wrapper center">
    <div class="square-estimate-wrapper">
        <div class="label">
            {assets.label1}
        </div>
        <div class="square square-all">
            <div class="square square-estimate" />
        </div>
    </div>

    <div class="square-actual-wrapper">
        <div class="label">
            {assets.label2}
        </div>
        <div class="square square-actual" />
    </div>
</div>

<style lang="scss">
    @import "@propublica/pp-v5-shared/src/css/column-setter-and-deps";
    .wrapper {
        margin: var(--spacing0) auto;
        max-width: 400px;
        min-width: 235px;
        display: flex;
        justify-content: center;
        min-width: 250px;
        align-items: end;
    }

    .label {
        font-family: var(--fonts-sans);
        font-size: var(--scale-2);
        color: var(--color-text-caption);
        line-height: var(--line-height-1);
        font-weight: 600;
        max-width: 160px;

        @include breakpoint-max(sm) {
            font-size: var(--scale-1);
            max-width: 150px;
            float: right;
        }
    }

    .square {
        aspect-ratio: 1 / 1;
        border: var(--intro-stroke);
    }

    .square-all {
        position: relative;
        width: 100px;
        background-color: var(--color-lawn);
        float: right;
    }

    .square-estimate {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 65.82px;
        border-style: dashed;
        border-bottom: none;
        border-right: none;
        border-left: dashed 1.6px #000;
        background-color: var(--color-dirt);
    }

    .square-actual {
        width: 34.9px;
        background-color: var(--color-dirt);
        margin-right: var(--spacing-1);
    }

    .square-estimate-wrapper {
        text-align: right;
        width: 120px;

        @include breakpoint-max(sm) {
            width: calc(50% - var(--spacing-2));
        }

        .label {
            margin-right: 0;
            margin-bottom: var(--spacing-1);
            text-align: right;
        }
    }

    .square-actual-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: end;
        margin-left: var(--spacing0);
        width: 120px;

        @include breakpoint-max(sm) {
            width: calc(50% - var(--spacing-2));
        }

        div {
            display: inline-block;
        }

        .label {
            margin-bottom: var(--spacing-1);
            width: 120px;
        }
    }
</style>
